import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';

// eslint-disable-next-line complexity
export const PageMeta = (props) => {
    const {
        metaTitle,
        metaDescription,
        heroFile,
        canonical,
        hreflangData,
        systemData: {humanReadableName, locale},
    } = props;

    const currentLocale = locale ? locale.replace(/_/g, '-').toLowerCase() : '';

    const brandName = humanReadableName.split('.')[0] || humanReadableName;

    if (hreflangData && hreflangData.length > 0) {
        hreflangData.push({href: canonical, hreflang: currentLocale});
    }

    const hreflangLinks =
        hreflangData &&
        hreflangData
            .map(({href, hreflang}, i) => {
                if (!href || !hreflang) {
                    return null;
                }
                return (
                    <link
                        key={i}
                        href={href}
                        hrefLang={hreflang}
                        rel="alternate"
                    />
                );
            })
            .filter((l) => l);

    return (
        <Fragment>
            <Helmet>
                <title>{`${metaTitle} | ${brandName}`}</title>
                <meta
                    name="description"
                    itemProp="description"
                    content={metaDescription}
                />
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:url" content={canonical} />
                <meta property="og:type" content="article" />
                <meta name="twitter:title" content={metaTitle} />
                <meta name="twitter:description" content={metaDescription} />

                {heroFile && (
                    <meta
                        property="og:image"
                        content={`${heroFile.url}?fm=jpg&w=1200`}
                    />
                )}

                {heroFile && (
                    <meta
                        name="twitter:image"
                        content={`${heroFile.url}?fm=jpg&w=1200`}
                    />
                )}

                <link rel="canonical" href={canonical} />
                {hreflangLinks}
            </Helmet>
        </Fragment>
    );
};

export default PageMeta;
